module.exports = __webpack_public_path__ + "media/Photo_to_Anime.385d79b3.webm";